import React from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { Button, Tooltip } from '@mui/material'
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot'
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation'
import BaseMapControl from './BaseMapControl'
import { getMapToggleButtonStyles } from './mapToggleButtonStyles'
import { setPointsOnlyMode } from '../../../redux/slices/Map/map'

/**
 * Control de "vista plana": oculta todos los modelos 3D y deja los árboles
 * como puntos a 100% de opacidad, para comparar de un vistazo verificados
 * (azul) vs no verificados (carmesí).
 */
class PointsOnlyControl extends BaseMapControl {
  constructor(store, theme) {
    super({ className: 'points-only-control' })
    this.store = store
    this.theme = theme
  }

  _renderContent() {
    const PointsOnlyButton = () => {
      const dispatch = useDispatch()
      const pointsOnlyMode = useSelector(state => state.mapState.pointsOnlyMode)

      const handleToggle = () => {
        dispatch(setPointsOnlyMode(!pointsOnlyMode))
      }

      const buttonStyles = getMapToggleButtonStyles(this.theme, pointsOnlyMode)

      const tooltipTitle = pointsOnlyMode
        ? 'Volver a vista 3D'
        : 'Comparar verificados y no verificados'

      // En modo solo-puntos el icono pasa a 3D (indica que al pulsar vuelven
      // los modelos 3D); fuera del modo muestra el icono de puntos.
      const Icon = pointsOnlyMode ? ThreeDRotationIcon : ScatterPlotIcon

      return (
        <Tooltip title={tooltipTitle} placement="right">
          <span>
            <Button onClick={handleToggle} size="small" sx={buttonStyles}>
              <Icon fontSize="small" />
            </Button>
          </span>
        </Tooltip>
      )
    }

    this._root.render(
      <Provider store={this.store}>
        <PointsOnlyButton />
      </Provider>,
    )
  }
}

export default PointsOnlyControl
